module.exports = __webpack_public_path__ + "static/logo-gruppo-920fac4b8699eeaa60c679f284f797f1.png";